import styled from "styled-components"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import {
  SectionWrapperStyles,
  ContentWrapperStyles,
  LeftColStyles,
  RightColStyles,
  HeadingWrapperStyles,
  CategoriesStyles,
  CategoryLinkStyles,
  ArticlesStyles,
} from "./articles-with-widgets-styles"
import { BreakPoints, media } from "../../helpers/rwd"

export interface Selectable {
  selected: boolean
}

export const SectionWrapper = styled.section`
  display: flex;
  padding: 60px 0;
  ${SectionWrapperStyles}
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  display: flex;
  justify-content: space-between;
  ${media.max(BreakPoints.desktop)} {
    flex-direction: column;
  }
  ${ContentWrapperStyles}
`

export const LeftCol = styled.div`
  width: 100%;
  max-width: 1074px;
  margin-right: 30px;
  ${media.max(BreakPoints.desktop)} {
    max-width: none;
    margin-right: 0;
  }
  ${LeftColStyles}
`

export const RightCol = styled.div`
  width: 100%;
  max-width: 322px;
  margin-top: 56px;
  ${media.max(BreakPoints.desktop)} {
    max-width: none;
    margin-top: 40px;
  }
  ${RightColStyles}
`

export const HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  & > h4 {
    margin: 0;
  }
  ${HeadingWrapperStyles}
`

export const Categories = styled.div`
  display: flex;
  flex-grow: 1;
  margin: 0 5%;
  ${media.max(BreakPoints.tablet)} {
    display: none; // TODO: dropdown
  }
  ${CategoriesStyles}
`

export const CategoryLink = styled.a<Selectable>`
  margin: 0 3%;
  cursor: pointer;
  ${CategoryLinkStyles}
`

export const Articles = styled.div`
  padding: 15px;
  ${ArticlesStyles}
`
